<template>
  <div v-if="loadingData !== null && loadingData !== undefined">
    <v-dialog scrollable v-model="loading" persistent max-width="400">
      <v-card>
        <v-card-title>
          {{ $t("components.membersmanagementtable.please_wait") }}
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.addEditUser"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          addEditUserTitle
        "
        :icon="addEditUserIcon"
        :color="$vuetify.theme.themes.light.success"
        v-if="dialogs.addEditUser"
      >
        <v-card-text>
          <v-form v-model="valid.addEditUser" ref="addEditUserForm">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <no-autocomplete-textfield
                    :label="$t('components.allowedusersmanagementtable.header.person_id')"
                    v-model="editedItem.PersonId"
                    :rules="[$rules.required]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <no-autocomplete-textfield
                    :label="$t('globals.firstname')"
                    v-model="editedItem.FirstName"
                    :rules="[$rules.required, $rules.validName]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <no-autocomplete-textfield
                    :label="$t('globals.lastname')"
                    v-model="editedItem.LastName"
                    :rules="[$rules.required, $rules.validLastName]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <pbas-date-picker
                    :label="$t('globals.dob')"
                    :value="editedItem.DateOfBirth"
                    @update-date="editedItem.DateOfBirth = $event"
                    :rules="[$rules.dateOfBirth]"
                    :allowedDates="dateOfBirthDates"
                  ></pbas-date-picker>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.addEditUser = false;
              editedIndex = -1;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.addEditUser"
            :loading="saving"
            color="primary"
            @click="addEditUserHandler()"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.addUsersFromCSV"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          $t('components.blockedusersmanagementtable.add_from_csv')
        "
        icon="file_present"
        :color="$vuetify.theme.themes.light.success"
        v-if="dialogs.addUsersFromCSV"
      >
        <v-card-text class="py-0">
          <v-row justify="center" class="pb-5">
            {{
            $t(
              "components.membersmanagementtable.add_from_csv_text"
            )
            }}
          </v-row>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">PersonId</th>
                  <th class="text-left">FirstName</th>
                  <th class="text-left">LastName</th>
                  <th class="text-left">DateOfBirth</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2619902</td>
                  <td>John</td>
                  <td>Doe</td>
                  <td>1982-11-24</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-form v-model="valid.addUsersFromCSV" ref="importFromCSVForm">
            <v-container fluid grid-list-md>
              <v-row justify="center">
                <v-col>
                  <file-uploader
                    ref="uploader"
                    :label="$t('components.membersmanagementtable.select_csv')"
                    accept=".csv"
                    :uploading="uploading"
                    :url="apiURL"
                    v-on:upload-started="onUploadStarted"
                    v-on:upload-error="onUploadError"
                    v-on:upload-completed="onUploadCompleted"
                    @lock-expired="$emit('close')"
                  ></file-uploader>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color
            text
            @click="
              dialogs.addUsersFromCSV = false;
              welcomeKitEmail = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.deleteBlockedUser"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="deleteDialogTitle"
        icon="person_remove"
        :color="$vuetify.theme.themes.light.error"
        v-if="dialogs.deleteBlockedUser"
      >
        <v-card-text>
          {{ deleteDialogText }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.deleteBlockedUser = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="error"
            @click="tryDeleteBlockedUser()"
          >
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="computedFloatActions"
      @itemsChanged="setData($event)"
      fileNamePrefix="users"
      :identifier="identifier"
      :noSearch="false"
      :showSelect="true"
      :selectActions="selectActions"
      @error="error = $event"
      :showExpand="false"
    ></pbas-data-table>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>

    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FileUploader from "../components/FileUploader";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { locker } from "../mixins/locker";
import BlockedUsersHeaders from "@/headers/BlockedUsers";

export default {
  name: "blocked-users-management-table",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    FileUploader
  },
  mixins: [locker],
  props: ["expandable", "odataUrl", "headersFunc", "identifier", "term"],
  data() {
    return {
      tab: 0,
      dialogs: {
        resendEmail: false,
        deleteBlockedUser: false,
        addUser: false,
        sendWelcomeKit: false,
        addEditUser: false,
        addUsersFromCSV: false,
      },
      uploadErrors: [],
      uploading: false,
      uploaded: false,
      uploadedOK: false,
      addEditUserTitle: null,
      addEditUserIcon: "drive_file_rename_outline",
      confirmEmail: null,
      welcomeKitEmail: null,
      sendWelcomeKitTitle: null,
      sendWelcomeKitText: null,
      portalUsers: [],
      currentUser: null,
      deleteDialogText: null,
      deleteDialogTitle: null,
      error: null,
      provider: undefined,
      floatActions: [],
      checkedFiles: [],
      filesToDelete: [],
      emailsToSendWelcomeKits: [],
      apiURL: null,
      rowActions: [
        // {
        //   name: "sendWelcomeKit",
        //   icon: "send_and_archive",
        //   title: "components.usersmanagementtable.send_welcome_kit",
        //   handler: (item) => {
        //     console.log("send welcome kit", item);
        //     this.currentUser = item;
        //     this.sendManyWelcomeKitsHandler()
        //   },
        //   visible: (item) => {
        //     return item;
        //   },
        // },
        {
          name: "editUser",
          icon: "drive_file_rename_outline",
          title: "components.allowedusersmanagementtable.edit_user",
          handler: (item) => {
            console.log("edit user", item);
            this.currentUser = item;
            this.openAddEditUserDialog(false);
          },
          visible: (item) => {
            return item;
          },
        },
        {
          name: "removeUser",
          icon: "person_remove",
          title: "components.allowedusersmanagementtable.remove_user",
          handler: (item) => {
            console.log("remove user", item);
            this.currentUser = item;
            this.checkedFiles = [];
            this.deleteBlockedUsersHandler();
          },
          visible: (item) => {
            return item;
          },
        },
      ],
      selectActions: [
        // {
        //   name: "sendManyWelcomeKits",
        //   icon: "send_and_archive",
        //   title: "components.usersmanagementtable.send_many_welcome_kits",
        //   color: "#00a5d7",
        //   handler: (item) => {
        //     this.checkedFiles = item;
        //     this.sendManyWelcomeKitsHandler();
        //   },
        // },
        {
          name: "deleteSelected",
          icon: "delete",
          title: "globals.delete",
          color: "#00a5d7",
          handler: (item) => {
            this.checkedFiles = item;
            this.deleteBlockedUsersHandler();
          },
        },
      ],
      computedFloatActions: [
        {
        name: "addUserToAllowed",
        icon: "person_add",
        color: "#007cb5",
        text: "components.blockedusersmanagementtable.add_user",
        handler: () => this.openAddEditUserDialog(true),
      },
        {
          name: "uploadAlowedUsers",
          icon: "group_add",
          color: "#007cb5",
          text: "components.allowedusersmanagementtable.upload_many_users",
          handler: () => this.dialogs.addUsersFromCSV = true,
        }
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: [],
      loading: false,
      expandedRowActions: [],
      editedItem: {},
      loadingData: false,
      saving: false,
      valid: {
        addUsersFromCSV: false,
      },
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings", }),
    url: function() {
      if (this.odataUrl !== null && this.odataUrl !== undefined)
        return this.odataUrl;
      return "plans/" + this.selectedPlan.Id + "/blocked-users";
    },
  },
  async created() {
    window.addEventListener("beforeunload", this.unload, { capture: true });
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
    await this.loadPlanData();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  async mounted() {
    this.apiURL =
              this.settings.APIURL +
              "plans/" +
              this.selectedPlan.Id +
              "/blocked-users-add-from-csv";
  },
  methods: {
    ...mapActions("plansMembers", [
      "deleteMemberPortalAccountPensionsPlan",
      "addOrUpdateBlockedUserRecord",
      "deleteBlockedUserRecord"
    ]),
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadError(err) {
      //console.log("ERR");
      //console.log(JSON.stringify(err));
      this.uploaded = true;
      this.uploadedOK = false;
      this.uploading = false;
      //console.log(err.response.data);
      if (Array.isArray(err.response.data)) {
        this.uploadErrors = err.response.data.slice(0, 100);
      } else {
        // this.uploadErrors = ["Server error"];
        this.error = err;
      }
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploadedOK = true;
      this.uploading = false;
      console.log(res);
      this.uploadErrors = [];
      this.uploadResult =
        "Upload successful";
      this.dialogs.addUsersFromCSV = false;
      this.$refs.table.getDataAsync();
      this.color = "success";
      this.message = "globals.success";
      this.snackbar = true;
    },
    onConfirmEmailPaste(event) {
      // console.log("P A S T E: ", event);
      event.preventDefault();
      return false;
    },
    openAddEditUserDialog(isAdd) {
      if (isAdd) {
        this.addEditUserIcon = "person_add";
        this.addEditUserTitle = this.$t("components.blockedusersmanagementtable.add_user");
      } else {
        this.editedItem = this.currentUser;
        this.addEditUserIcon = "drive_file_rename_outline";
        this.addEditUserTitle = this.$t("components.blockedusersmanagementtable.edit_user_{0}", [
          this.getName(),
        ]);
      }
      this.dialogs.addEditUser = true;
    },

    dateOfBirthDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d <= d2;
    },

    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
    async loadPlanData(filter = null) {
      this.loadingData = true;
      try {
        let headers = BlockedUsersHeaders;
        if (headers.length === 0) {
          this.error = {
            customMessage: this.$t("errors.no_headers"),
          };
          return;
        }

        this.headers = headers;
        if (!filter) {
          this.$nextTick(()=>{
            this.provider = new PbasOData(this.$axiosHttp, this.url, BlockedUsersHeaders);
          })
        } else {
        const pr = new PbasOData(this.$axiosHttp, this.url, BlockedUsersHeaders);
          pr.filter = filter;
          this.provider = pr;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingData = false;
      }
    },
    setData(items) {
      console.log("setData emit setUsers");
      this.$emit("setUsers", items);
    },
    getName() {
      return this.currentUser && this.currentUser.PersonId || "";
    },
    async addEditUserHandler() {
      try {
        this.saving = true;
        await this.addOrUpdateBlockedUserRecord({
          planIdentityId: this.selectedPlan.Id,
          payload: [this.editedItem],
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.addEditUser = false;
        this.editedItem = {};
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      finally {
        this.saving = false;
      }
    },

    deleteBlockedUsersHandler() {
      const deleteMany = this.checkedFiles.length > 0;
      if (deleteMany) {
          this.deleteDialogTitle = this.$t(
            "components.blockedusersmanagementtable.delete_users"
          );
          this.deleteDialogText = this.$t(
            "components.blockedusersmanagementtable.confirm_delete_text_many_{0}",
            [this.checkedFiles.length]
          );
          this.filesToDelete = this.checkedFiles;
        } else {
          this.deleteDialogTitle = this.$t(
            "components.blockedusersmanagementtable.delete_user"
          );
          this.deleteDialogText = this.$t(
            "components.blockedusersmanagementtable.confirm_delete_text_{0}",
            [this.getName()]
          );
          this.filesToDelete = [this.currentUser];
        }
        this.dialogs.deleteBlockedUser = true;
    },

    async tryDeleteBlockedUser() {
      try {
        this.saving = true;
        await this.deleteBlockedUserRecord({
          planIdentityId: this.selectedPlan.Id,
          payload: this.filesToDelete,
        });
        this.dialogs.deleteBlockedUser = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItem = {};
        this.currentUser = null;
        this.filesToDelete = [];
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>

<style>
.background-red {
  background-color: red;
}
.background-green {
  background-color: green;
}
.full-width {
  width: 100%;
}
.terminated {
  background-color: red;
}
</style>
